import { useTranslation } from "react-i18next"

import { Text, Div } from "ui"

import AuthorSVG from 'assets/brand/avatar-author.svg'


const Author = ({ src, alt, name, videos }) => {

  const { t } = useTranslation()

  const source = src || AuthorSVG

  const videosText = !videos
    ? ''
    : videos === 1
      ? `1 ${t('content').toLowerCase()}`
      : `${videos} ${t('contents').toLowerCase()}`


  return (
    <Div
      display='flex'
      margin-top={12}
      margin-bottom={16}
    >
      <Div height={32} border-radius={6} overflow='hidden'>
        <img
          height='100%'
          src={source}
          alt={alt}
        />
      </Div>

      <Div
        display='flex'
        flex-direction='column'
        justify-content='center'
        margin-left={8}
      >
        <Text size='xs' weight='medium' color='headline'>
          {name}
        </Text>

        <Text size='xs'>
          {videosText}
        </Text>
      </Div>
    </Div>
  )
}

export default Author